import React from 'react';

const StatsBox = ({ icon, label, children, className = "" }) => {
  return (
    <div
      className={`bg-[#FFFFFF]/20 backdrop-blur-sm rounded-2xl p-3 flex items-center gap-2 h-[60px] ${className}`}
    >
      {icon}
      <div className="flex flex-col">
        <span className="text-[10px] text-white/80">{label}</span>
        {children}
      </div>
    </div>
  );
};

export default StatsBox;
